<template>
	<el-container class="media-release" style="padding: 10px">
		<left-menu  :width="'220px'"></left-menu>
		<div class="contentBox" :style="{height: clientHeight}">
			<keep-alive>
                <router-view></router-view>
            </keep-alive>
		</div>
	</el-container>
</template>
<script>
	import leftMenu from '@/components/leftMenu/left-menu'
	export default {
		name: "media-release",
		components:{leftMenu},
		data() {
			return {
				clientHeight: '',
			}
		},
		created() {
			this.clientHeight = (document.body.clientHeight - 120) + 'px';
		},
	}
</script>

<style lang="less" scoped>
	.media-release {
		display: flex;
		height: calc(100vh - 100px);
		.contentBox {
			// flex: 1;
			width: calc(100vw - 240px);
			height: 100%;
		}
	}
</style>
